import { StrictMode } from 'react';
import { createRoot } from  'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App';
import HomePage from './pages/HomePage';
import ContextPage from './pages/ContextPage';
import SessionPage from './pages/SessionPage';
import SynthesisPage from './pages/SynthesisPage';
import FinalPage from './pages/FinalPage';
import CompatiblePage from './modules/compatible/CompatiblePage';
import CompatibleRespond from './modules/compatible/CompatibleRespond';
import CompatibleResult from './modules/compatible/CompatibleResult';
import './index.css';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '/',
        element: <HomePage />,
      },
      {
        path: '/context',
        element: <ContextPage />,
      },
      {
        path: '/session/:sessionId',
        element: <SessionPage />,
      },
      {
        path: '/synthesis/:sessionId',
        element: <SynthesisPage />,
      },
      {
        path: '/final',
        element: <FinalPage />,
      },
      {
        path: '/compatible',
        element: <CompatiblePage />,
      },
      {
        path: '/compatible/respond/:sessionId',
        element: <CompatibleRespond />,
      },
      {
        path: '/compatible/result/:sessionId',
        element: <CompatibleResult />,
      },
    ],
  },
]);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
);